"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMessageJsx = exports.getMessage = exports.getMessageCode = void 0;
const react_1 = __importDefault(require("react"));
const getMessageCode = function getMessageCode(messages, code) {
    if (!messages || typeof messages !== 'object')
        return undefined;
    if (messages.get && typeof messages.get === 'function') {
        return messages.get(code);
    }
    return messages[code];
};
exports.getMessageCode = getMessageCode;
const getMessage = function getMessage(messages, code, args) {
    let message = (0, exports.getMessageCode)(messages, code);
    if (args && message) {
        for (const i in args) {
            if (Object.hasOwnProperty.call(args, i)) {
                const find = `\\{${i}\\}`;
                const re = new RegExp(find, 'g');
                message = message.replace(re, `${args[i]}`);
            }
        }
    }
    return message;
};
exports.getMessage = getMessage;
const getMessageJsx = function getMessageJsx(messages, code, args) {
    const message = (0, exports.getMessageCode)(messages, code);
    if (!args || !message)
        return message;
    // turn "foo {0} bar" into ['foo ', '0', ' bar']
    const messageParts = message.split(/{(\d*)}/);
    return messageParts.map((val, i) => {
        // every second item should be replaced with an arg
        if (i % 2 === 0)
            return val;
        let replacement = args[val];
        if (!replacement)
            return `{${val}}`;
        if (react_1.default.isValidElement(replacement)) {
            replacement = react_1.default.cloneElement(replacement, { key: val });
        }
        return replacement;
    });
};
exports.getMessageJsx = getMessageJsx;
//# sourceMappingURL=messageCode.js.map